<template>
  <div class="mb-4">
    <div v-if="loading">
      <h4>Ожидайте...</h4>
    </div>
    <div v-else>
      <div
        v-if="
          data.shop &&
          data.shop.location &&
          data.shop.location.location &&
          region
        "
      >
        <div>
          <label>Укажите местность вашей локации</label>
          <select class="form-control mb-3" v-model="senderDelivery">
            <option value="1">Городская местность</option>
            <option value="2">Дальний поселок</option>
          </select>
        </div>

        <button class="btn btn-info btn-icon mw" @click="sendRequest">
          {{ "start" | setText("Сформировать заявку") }}
        </button>
      </div>
      <div v-else>
        <h4 class="mt-3 text-danger">
          Нельзя оформить заявку - нет синхронизации локаций BTS
        </h4>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      const options = await this.initOptions();
      console.log(options);

      // console.log(optionStirng);
      // return false;

      if (
        !options ||
        (options && !options.length) ||
        !options.length
        // && options[0].declarations.length == 0
      ) {
        this.$notify({
          title: "Ошибка",
          message: "Добавьте товары",
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
        });

        return false;
      }

      this.loading = true;

      this.getPrice(options);
    },
    async getPrice(options) {
     
      const url = `${this.currentRequest.service.api_endpoint_url}v1/order/calculate`;
      const method = "post";
      //SET
      let data = {
        senderCityId: this.region.exchange_id, //DYNAMIC
        receiverCityId: 196,
        weight: this.data.weight,
        volume: this.data.volume,
        senderDelivery: this.senderDelivery, //DYNAMIC
        receiverDelivery: 1,
      };
      this.$dialog
        .confirm(`Убедитесь, что объем и вес правильный`, {
          okText: "Верно | To'g'ri",
          cancelText: "Нет | Yo'q",
        })
        .then(() => {
          this.$loading(true);
          var instance = this.$http.create();
          delete instance.defaults.headers.common["Authorization"];
          delete instance.defaults.headers.common["bid"];
          delete instance.defaults.headers.common["localization"];
          delete instance.defaults.headers.common["shop"];
          delete instance.defaults.headers.common["device"];
          delete instance.defaults.headers.common["tab"];
          delete instance.defaults.headers.common["root"];
          delete instance.defaults.headers.common["version"];
          const config = {
            method: method,
            url: url,
            data: data,
            headers: {
              common: {
                Authorization:
                  "Bearer " + this.currentRequest.service.api_token,
              },
            },
          };
          //REQUEST
          return instance(config)
            .then((response) => {
              this.$loading(false);
              const responseData = response.data;
              this.sendData(options);
              this.$emit("input", {
                service_request: {
                  state: "new",
                  service: "bts",
                  exchange_id: "",
                  response: JSON.stringify(responseData),
                  body: JSON.stringify(data),
                },
              });
              return responseData;
            })
            .catch((error) => {
              this.$loading(false);
              this.loading = false;
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async initOptions() {
      const resultArray = [];
      this.data.transfer_containers.forEach((item) => {
        item.trade_ins.forEach((tradeIn) => {
          resultArray.push({
            name: tradeIn.code,
            code: tradeIn.code,
            count: 1, // Ваше значение
          });
        });
      });

      return resultArray;
    },
    async initOptionString() {
      let resultString = "Номера сейф-пакетов: ";

      this.data.transfer_containers.forEach((item) => {
        item.trade_ins.forEach((tradeIn) => {
          resultString += ` ${tradeIn.code} (${tradeIn.price} UZS); `;
        });
      });

      return resultString;
    },
    async sendData(options) {
      const url = `${this.currentRequest.service.api_endpoint_url}v1/order/add`;
      const method = "post";
     // const optionStirng = await this.initOptionString();

      //SET

      let data = {
        senderDelivery: this.senderDelivery,
        senderCityId: this.region.exchange_id,
        senderAddress: this.data.shop.address,
        senderReal: this.data.sender_name,
        senderPhone: this.data.sender_phone,
        weight: this.data.weight,
        // is_test: 1,
        packageId: 7,
        postTypeId: 12,
        postTypes: options,
        receiverDelivery: 1,
        receiver: "Эрматов Сардор Шухратович",
        receiverCityId: 196,
        receiverAddress: "ул. Паркент, дом 327",
        volume: this.data.volume,
        urgent: 0,
        takePhoto: 0,
        piece: 1,
        receiverPhone: "+998998158689",
      };

 

      var instance = this.$http.create();
      delete instance.defaults.headers.common["Authorization"];
      delete instance.defaults.headers.common["bid"];
      delete instance.defaults.headers.common["localization"];
      delete instance.defaults.headers.common["shop"];
      delete instance.defaults.headers.common["device"];
      delete instance.defaults.headers.common["tab"];
      delete instance.defaults.headers.common["root"];
      delete instance.defaults.headers.common["version"];
      const config = {
        method: method,
        url: url,
        data: data,
        headers: {
          common: {
            Authorization: "Bearer " + this.currentRequest.service.api_token,
          },
        },
      };
      //REQUEST
      return instance(config)
        .then(async (response) => {
          const responseData = response.data;
          if (responseData.orderId) {
            this.$emit("input", {
              exchange_id: responseData.orderId,
              name: responseData.barcode,
              exchange_status_id: responseData.status.id,
              service_request: {
                state: "sent",
                service: "bts",
                exchange_id: "",
                response: JSON.stringify(responseData),
                body: JSON.stringify(data),
              },
            });
          } else {
            this.$notify({
              title: "Не удалось создать заказ",
              message: "Попробуйте еще раз",
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  props: ["value", "data", "currentRequest", "region"],

  data: () => ({
    loading: false,
    init: false,
    senderDelivery: 1,
  }),
};
</script>
<style>
</style>
 